export interface UtilSelect {
  name: string;
  value?: number | string;
}

export interface ApiResponse {
  status?: string;
  messageid?: string;
  message?: string;
}
